// Do not remove these.
import EpubMaker from './js-epub-maker.js';
import { uuid } from 'uuid';
import { getChapters, getGuidebookChaptersList } from './utils.js';
import { decodeHtml } from '../components/guidebooks/FeaturedGuidebooks.js';
import sanitizeHtml from 'sanitize-html';
//https://jsfiddle.net/tm37cj9p/

let slugify = (text) => {
  return text
    .toString()
    .toLowerCase()
    .replace(/\s+/g, '-') // Replace spaces with -
    .replace(/[^\w-]+/g, '') // Remove all non-word chars
    .replace(/--+/g, '-') // Replace multiple - with single -
    .substring(0, 20); // Trim - from start and end of text
};

let constructEpub = (ebookTobeGenerated) => {
  let epub = new window.EpubMaker()
    .withUuid('test')
    .withTemplate('idpf-wasteland')
    .withAuthor('UW Shelter Medicine')
    .withLanguage('en-US')
    .withModificationDate(new Date(2015, 8, 7))
    .withRights({
      description:
        'This guidebook is part of a resource library maintained jointly by the Shelter Medicine Programs at the University of Wisconsin and UC Davis. The latest version of this document and all other shared resources can be found at their respective websites. Published under the Attribution-NonCommercial-NoDerivatives 4.0 International.',
      license: 'https://creativecommons.org/licenses/by-nc-nd/4.0/',
    })
    .withTitle(ebookTobeGenerated.title)
    .withSection(
      new window.EpubMaker.Section(
        'frontmatter',
        'frontmatter',
        { title: ebookTobeGenerated.title },
        false,
        true
      )
    )
    .withSection(
      (function () {
        let body = new window.EpubMaker.Section(
          'bodymatter',
          'bodymatter',
          { title: '' },
          false,
          true
        );

        ebookTobeGenerated.sections.forEach((section) => {
          // remove nbsp from content
          section.content = section.content.replace(/&nbsp;/g, ' ');
          body.withSubSection(
            new window.EpubMaker.Section(
              'section',
              `${slugify(section.title)}`,
              { title: section.title, content: section.content },
              false,
              true
            )
          );
        });
        return body;
      })()
    );

  return epub;
};

let downloadGuidebookEpub = async (guidebookSlug) => {
  let guidebookContent = await getAllGuidebookInfo(guidebookSlug);
  let epub = constructEpub(guidebookContent);
  console.log(epub);
  epub.downloadEpub(false, false);
};

let getAllGuidebookInfo = async (guidebookSlug) => {
  let ebook = {
    title: '',
    slug: '',
    sections: [],
  };

  // Fetch all the chapters in the guidebook.
  let chapters = await getChapters(guidebookSlug);
  // Get the first chapter and set the title.rendered property to the title of the Ebook
  ebook.title = decodeHtml(chapters[0].title.rendered);

  // create the slug and make it only letters
  ebook.slug = ebook.title.replace(/[^a-zA-Z ]/g, '').replace(/ /g, '-');

  // Loop through the chapters in order and add them to the ebook.
  chapters.forEach((chapter) => {
    let section = {
      title: '',
      content: '',
    };
    section.title = decodeHtml(chapter.title.rendered);
    section.content = sanitizeHtml(chapter.content.rendered, {
      allowedTags: sanitizeHtml.defaults.allowedTags.concat(['img']),
      allowedAttributes: {
        ...sanitizeHtml.defaults.allowedAttributes,
        img: ['src'],
      },
      selfClosing: sanitizeHtml.defaults.selfClosing.concat(['img']),
      // Remove all id attributes
      transformTags: {
        '*': (tagName, attribs) => {
          if (attribs.id) {
            delete attribs.id;
          }
          return { tagName, attribs };
        },
      },
    });
    ebook.sections.push(section);
  });

  return ebook;
};

export { downloadGuidebookEpub, getAllGuidebookInfo };
